export const DATE_REDUCER_KEY = 'dateStore';
export type DATE_REDUCER_KEY = typeof DATE_REDUCER_KEY;
export type DateStore = {
  currentDate: string;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [DATE_REDUCER_KEY]: DateStore;
  }
}
